import React from 'react'
import { IpostingItem } from '@typings/posting/posting.interface';
import { CollectionPath } from '@typings/collections.enum';
import styled from 'styled-components';
import Theme from '@styles/Theme';
import TimeAgo from '@components/dataDisplay/TimeAgo';

const Item = styled.div`
  width: 100%;
  height: 100%;
  background: var(--cardBackgroundColor);
  border: 1px solid var(--cardLineColor);
  border-radius: var(--cardBorderRadius);
  overflow: hidden;

  box-shadow: ${Theme.shadow.card};
  display: flex;
  align-items: center;


  &:hover {
    background-color: var(--inkColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const TitleSec = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  gap: 4px;
   padding: 8px 12px;
   width: 100%;
`;

const ThumbImg = styled.img`
  height: 100%;
  max-height: 36px;
  flex-shrink: 0;
  object-fit: cover;
`;

const InfoSec = styled.div`
  display: flex;
  gap: 4px;
  font-size: 12px;
  color: var(--subTextColor);
  word-break: break-all;
  flex-shrink: 0;
`;

type Props = {
  data: IpostingItem;
  handleClick: (arg0: any, string) => void;
  iconImg: string;
}

function NoticeIconBox({ data, handleClick, iconImg }: Props) {
  return (
    <Item onClick={() => handleClick(CollectionPath.POSTING, data.id)}>
      {iconImg && <ThumbImg src={iconImg} alt="" />}
      <TitleSec>
        <div className="title">{data.title}</div>
        <InfoSec>
          <TimeAgo createdAt={data.createdAt} showTime={false} />
        </InfoSec>
      </TitleSec>
    </Item>
  )
}

export default NoticeIconBox